import { withStyles } from "@material-ui/core/styles";
import SrInput from "../SrInput";

const SrFilterSelect = withStyles((theme) => ({
  root: {
    fontWeight: "normal",
    paddingRight: theme.spacing(1),
    "& fieldset": {
      border: "none",
    },
    "& .MuiInputBase-root": {
      fontWeight: "normal",
      backgroundColor: "transparent",
      color: theme.palette.buttonDefault.text,
      "& :hover": {
        backgroundColor: theme.palette.buttonDefault.dark,
      },
    },
    "& .MuiInputBase-input": {
      fontWeight: "normal",
      fontSize: theme.typography.pxToRem(13),
    },
    "& .MuiSvgIcon-root": {
      color: theme.palette.buttonDefault.text,
    },
  },
}))(SrInput);

export default SrFilterSelect;
